import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	shouldRefetch: false,
};

const dataRefetch = createSlice({
	name: 'dataRefetch',
	initialState,
	reducers: {
		setRefetch(state, action: PayloadAction<boolean>) {
			state.shouldRefetch = action.payload;
		},
	},
});

export const { setRefetch } = dataRefetch.actions;
export default dataRefetch.reducer;
